
      
<div class="container1">
 <div style="text-align: center; margin-top: 20px;">
  <img src="https://app.flowtrics.com/assets/images/logo/flowtrics_logo.png" alt="Flowtrics Logo" style="height: 60px; margin-bottom: 10px;" />
  <h2>eSign PDF</h2>
</div>

  <div class="upload-box" >

    <div class="upload-content" [hidden]="showUploadBox==false">
      <img src="../../../../../assets/icons/fileType/pdf_icon.svg" alt="PDF Icon" class="icon"/>
      <button (click)="Input.click()" class="upload-btn">
        CHOOSE FILES
      </button>     
      <input #Input hidden="true" type="file" (change)="selectFilesForWithoutParentId($event,Input)" hidden accept=".pdf"/>
    </div>

    <div [hidden]="showUploadBox==true">
      <p class="animated-message">{{message}}</p>
    </div>
  </div>


   <p class="description">
    Add your electronic signature to any PDF in just a few clicks. No printing, scanning, or downloads—just fast, secure e-signing.
  </p>
  <p class="contact">
   
  </p>

</div>


<!-- <div class="outerLoader" [hidden]="spinner">
  <div id="container" >
    <div class="divider" aria-hidden="true"></div>
    <p class="loading-text" aria-label="Loading">
      <span class="letter" aria-hidden="true">L</span>
      <span class="letter" aria-hidden="true">o</span>
      <span class="letter" aria-hidden="true">a</span>
      <span class="letter" aria-hidden="true">d</span>
      <span class="letter" aria-hidden="true">i</span>
      <span class="letter" aria-hidden="true">n</span>
      <span class="letter" aria-hidden="true">g</span>
    </p>
  </div>
</div> -->

